import { AUTH_INIT_COMPLETE, USER_UPDATE_COMPLETE, LOGIN_STATUS, ACCOUNT_TYPE, LOGOUT_COMPLETE, SET_AUTH_ERROR, SET_LOGIN_STATUS, authReducer, authActions, authSelectors } from './reducer/auth-reducer';

import { authSagas } from './sagas/auth-sagas';
import { saveLoginCookie, getLoginCookie, deleteLoginCookie } from './services/auth-helpers';

var publicAuthActions = {
  initializeAuth: authActions.initializeAuth,
  loginUser: authActions.loginUser,
  consolidatedLoginUser: authActions.consolidatedLoginUser,
  logout: authActions.logout,
  clearAuthError: authActions.clearAuthError,
  refreshUser: authActions.refreshUser,
  updateUser: authActions.updateUser,
  setLoginStatus: authActions.setLoginStatus,
  setAuthError: authActions.setAuthError
};

var publicAuthSelectors = {
  authToken: authSelectors.authToken,
  refreshToken: authSelectors.refreshToken,
  loginStatus: authSelectors.loginStatus,
  accountType: authSelectors.accountType,
  loginRedirectUrl: authSelectors.loginRedirectUrl,
  accountList: authSelectors.accountList,
  userInfo: authSelectors.userInfo,
  userId: authSelectors.userId,
  userName: authSelectors.userName,
  userInterfaceLanguage: authSelectors.userInterfaceLanguage,
  targetLanguageCode: authSelectors.targetLanguageCode,
  errorMsg: authSelectors.errorMsg,
  clientId: authSelectors.clientId,
  productRights: authSelectors.productRights
};

export { AUTH_INIT_COMPLETE, USER_UPDATE_COMPLETE, LOGIN_STATUS, ACCOUNT_TYPE, LOGOUT_COMPLETE, SET_AUTH_ERROR, SET_LOGIN_STATUS, publicAuthActions as authActions, publicAuthSelectors as authSelectors, authReducer, authSagas, saveLoginCookie, getLoginCookie, deleteLoginCookie };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-auth/es/index.js
// module id = 23
// module chunks = 0